/**
 * Sandbox Guide Accordion
 *
 * Renders the in-flight subset of the `canary sandbox guide` content as
 * collapsible sections. The CLI guide ships 6 sections; the web app shows
 * the 4 operational ones (goal/artifacts/actions/verify) — the other two
 * (research/checklist) are pre-authoring concerns that don't apply once
 * a sandbox is already running.
 */
import { CollapsibleSection, Text } from '@chatsdet/ui';
import { SANDBOX_GUIDE_SECTIONS } from '@chatsdet/content';

const IN_FLIGHT_SLUGS = new Set(['goal', 'artifacts', 'actions', 'verify']);
const IN_FLIGHT_SECTIONS = SANDBOX_GUIDE_SECTIONS.filter((s) =>
  IN_FLIGHT_SLUGS.has(s.slug)
);

export function SandboxGuideAccordion() {
  return (
    <div className="flex flex-col">
      <Text size="xs" weight="medium" className="text-muted-foreground uppercase tracking-wide mb-1">
        Sandbox guide
      </Text>
      <Text size="xs" color="muted" className="mb-2">
        Operational reference — same content as <code>canary sandbox guide</code>.
      </Text>
      {IN_FLIGHT_SECTIONS.map((section) => (
        <CollapsibleSection key={section.slug} label={section.title}>
          <pre className="whitespace-pre-wrap font-mono text-[12px] leading-relaxed text-foreground/90 bg-muted/40 rounded-md p-3 overflow-x-auto">
            {section.content}
          </pre>
        </CollapsibleSection>
      ))}
    </div>
  );
}

SandboxGuideAccordion.displayName = 'SandboxGuideAccordion';
